/* @flow */

export const availabilityManualSection = 'availabilityManualSection';
export const availabilityManualTakeover = 'availabilityManualTakeover';
